var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input__wrapper" },
    [
      _c("ma-date-picker", {
        staticClass: "priceDamage",
        attrs: {
          icon: "calendar",
          literal: _vm.$t("damageTypeCpi.calendarLabel.literal"),
          handleChangeInput: _vm.handleChangeInputDate
        }
      }),
      _c("ma-input-text", {
        staticClass: "priceDamage",
        attrs: {
          type: "text",
          name: "priceDamageCpi",
          icon: "coins",
          col: "1",
          literal: _vm.$t("damageTypeCpi.priceDamage.literal")
        },
        model: {
          value: _vm.inputValPrice,
          callback: function($$v) {
            _vm.inputValPrice = $$v
          },
          expression: "inputValPrice"
        }
      }),
      _c(
        "button",
        {
          staticClass: "btn mainBlue grid__cell-md-4",
          attrs: { disabled: _vm.isDisabledButton },
          on: { click: _vm.handleAddDamagesCpi }
        },
        [_vm._v(_vm._s(_vm.$t("actions.addDamage")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }